import type { ReceiptTemplate } from '../schema';

export const hiltonTemplate: ReceiptTemplate = {
  id: 'hilton',
  name: 'Hilton Hotel Receipt',
  brand: 'HILTON',
  description: 'Hilton Hotels receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'hilton-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/hilton.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 22,
        addressLines: [
          'HILTON MONSTERVILLE',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'hilton-guest',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'guest', label: 'Guest:', value: 'JOHN DOE' },
          { id: 'room', label: 'Room:', value: '847' },
        ],
        column2: [
          { id: 'checkin', label: 'Check-In:', value: '01/02/2026' },
          { id: 'checkout', label: 'Check-Out:', value: '01/04/2026' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'hilton-charges',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'room1', label: 'ROOM 01/02', value: '189.00', isBold: false, isLarge: false },
          { id: 'room2', label: 'ROOM 01/03', value: '189.00', isBold: false, isLarge: false },
          { id: 'parking', label: 'PARKING', value: '45.00', isBold: false, isLarge: false },
          { id: 'subtotal', label: 'SUBTOTAL', value: '423.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX (14%)', value: '59.22', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '482.22', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'hilton-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [
          { id: 'auth', label: 'Auth:', value: '059746' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'hilton-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'HILTON HONORS MEMBER\nPOINTS EARNED: 2,411\n\nTHANK YOU FOR STAYING',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

